import "./style.scss";

import React, { useEffect, useState } from "react";
import { Typography, Box, Button, CircularProgress, Skeleton, Dialog, DialogContent, DialogActions, IconButton } from "@mui/material";

import TopBar from "../../../components/TopBar";

import BottomBar from "../../../components/BottomBar";
import EmailHarvesting from "../../../components/EmailHarvesting";

import ProductDownload from "../../../components/ProductDownload";
import { getProduct } from "../../../util/api/productApi";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../../actions/notificationActions";
import { AmplifierBanner, CabinetBanner, StandAloneBanner, MainBanner } from "../../../components/Products/BassDistant";

import AccountDialog from "../../../components/AccountDialog";
import BuyButton from "../../../components/BuyButton";

import { Helmet } from 'react-helmet';
import OverviewBanner from "../../../components/Products/BassDistant/Overview";
import { PriceContent } from "../../../components/PriceComponents";
import PrePredals from "../../../components/Products/BassDistant/PrePedals";
import EQBanner from "../../../components/Products/BassDistant/EQBanner";
import PostFX from "../../../components/Products/BassDistant/PostFx";
import BassSim from "../../../components/Products/BassDistant/BassSim";
import ParametricEQ from "../../../components/Products/BassDistant/ParametricEQ";
import PluginUtilities from "../../../components/Products/BassDistant/Utilities";

import originOfMadness from "../../../static/images/distant_bass_suite/origin-of-madness.jpeg"
import asiaAustralia from "../../../static/images/distant_bass_suite/asia-australia.jpeg"
import usaTour2025 from "../../../static/images/distant_bass_suite/usa-tour-2025.jpeg"
import CloseIcon from '@mui/icons-material/Close';

import ReactPixel from 'react-facebook-pixel';
import { useSearchParams } from "react-router-dom";

const PRODUCT_ID = "distant-bass-suite"

const ExtraContentRightTopBar = ({ trigger, onTrial, priceContent, product }) => {
  return <Box
    className={trigger ? "reveal active" : "reveal"}
    sx={{
      p: 2,
      display: "flex",
      flexDirection: "row",
      columnGap: 2,
      color: "#fff",
      alignItems: "center"
    }}>
    {priceContent}
    <Button
      variant="outlined"
      size="small"
      onClick={onTrial}
    >
      Free Trial
    </Button>
    <BuyButton size="small" product={product} sx={{ width: "100px" }} />
  </Box>
}

const ExtraContentMobile = ({ product, priceContent }) => {
  return <Box sx={{
    p: 2,
    display: "flex",
    flexDirection: "row",
    columnGap: 2,
    color: "#fff",
    alignItems: "center"
  }}>
    {priceContent}
    <BuyButton size="small" product={product} sx={{ width: "90px" }} />
  </Box>
}

const PromoValues = {
  "MADNESS20": <><b>20% discount</b></>,
  "USA20": <><b>20% discount</b></>,
  "CodeDistant30Tour": <>exclusive liveshow <b>30% discount</b></>,
  "Code50DistantAsia": <>exclusive liveshow <b>50% discount</b></>
}

const Tourname = {
  "MADNESS20": "The Origin of Madness Tour",
  "USA20": "The Evisceratour",
  "CodeDistant30Tour": "The Asia & Australia 2025 Tour",
  "Code50DistantAsia": "The Asia & Australia 2025 Tour"
}

const Images = {
  "MADNESS20": originOfMadness,
  "USA20": usaTour2025,
  "CodeDistant30Tour": asiaAustralia,
  "Code50DistantAsia": asiaAustralia
}


const PromoPopup = ({ open, onClose, product, code }) => {
  return <Dialog open={open} onClose={onClose}
    PaperProps={{
      elevation: 10,
    }}
  >
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: "white",
      })}
    > <CloseIcon /></IconButton>
    <img src={Images[code]} alt={Tourname[code] || "BassSuite - Distant promotion"} />

    <DialogContent sx={{ justifyContent: "center", textAlign: "center" }}>
      <Box>
        <i>{Tourname[code]}</i> is here! <br />Claim your {PromoValues[code]} now at checkout!
      </Box>

      <Box sx={{ mt: 3 }}>
        <BuyButton text={"Claim Offer"} product={product}></BuyButton>
      </Box>
    </DialogContent>
  </Dialog >
}

const ReclameBanner = ({ code }) => {
  return (
    <Box sx={{
      bottom: 0,
      width: "100%",
      position: 'fixed',
      alignItems: "center",
      textAlign: "center",
      padding: 2,
      background: "black",
      zIndex: 10,
    }}>
      <Typography variant="h5" sx={{ fontSize: { xs: 16, md: 28 } }}><i>{Tourname[code]}</i> is here! Claim your {PromoValues[code]} now at checkout!</Typography>
    </Box>
  )
}

const BassDistantSuitePage = ({ useHelmet = true }) => {

  const [searchParams, setSearchParams] = useSearchParams();


  const [downloadOpen, setDownloadOpen] = useState(false);
  const [product, setProduct] = useState(undefined)
  const [loading, setLoading] = useState(true)
  const [price, setPrice] = useState(undefined)
  const [trigger, setTrigger] = useState(false);
  const [accountDialogOpen, setAccountDialogOpen] = useState(false);
  const [promoOpen, setPromoOpen] = useState(false)
  const [promoCode, setPromoCode] = useState(null)
  const [showPromoBanner, setShowPromoBanner] = useState(false);

  window.onscroll = function () {
    var scrollLimit = 500;
    setTrigger(window.scrollY >= scrollLimit);
  };

  const dispatch = useDispatch();
  const state = useSelector((state) => state)

  const fetchProduct = () => {
    getProduct(PRODUCT_ID).then((res) => {
      setLoading(false)
      setProduct(res?.data)

    }).catch(() => {
      setLoading(false)
      dispatch(setError("Something went wrong, please contact support."))
    })
  }

  useEffect(() => {
    fetchProduct()
    // eslint-disable-next-line
  }, [state?.token])

  useEffect(() => {
    const promocode = searchParams.get("promo");
    setPromoCode(promocode?.toUpperCase());
    // eslint-disable-next-line
  }, [searchParams])

  useEffect(() => {
    setTimeout(() => { setPromoOpen(promoCode !== null && promoCode !== undefined) }, 666)

  }, [promoCode])

  useEffect(() => {
    if (product) {
      setPrice(`€${(product?.default_price?.unit_amount / 100).toFixed(2)}`)
    }
  }, [product])

  const handleTrial = () => {
    setDownloadOpen(true)
  }




  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {useHelmet && <Helmet>
        <title>WaveMind Audio | BassSuite - Distant</title>
        <link rel="canonical" href="https://wavemind.net/product/distant-bass-suite" />
      </Helmet>}
      <TopBar
        hideTrigger={trigger}
        rightExtraAction={<ExtraContentRightTopBar trigger={trigger} product={product} onTrial={handleTrial} priceContent={<PriceContent name="BassSuite - Distant" product={product} />} />}
        extraContentMobile={trigger ? <ExtraContentMobile product={product} priceContent={<PriceContent name="BassSuite - Distant" product={product} />} /> : undefined} />

      <PromoPopup code={promoCode} open={promoOpen} product={product} onClose={() => { setPromoOpen(false); setShowPromoBanner(true) }} />
      <ProductDownload requireEmail open={downloadOpen} onClose={() => setDownloadOpen(false)} productID={PRODUCT_ID} />
      <AccountDialog open={accountDialogOpen} onClose={() => { setAccountDialogOpen(false) }} />

      <MainBanner price={price} product={product} onTrial={handleTrial} />
      {showPromoBanner && <ReclameBanner code={promoCode} />}
      <OverviewBanner />
      <AmplifierBanner />
      <BassSim />
      <PrePredals />
      <CabinetBanner />
      <EQBanner />
      <PostFX />
      <ParametricEQ />
      <PluginUtilities />
      <StandAloneBanner />
      <EmailHarvesting />
      <BottomBar />
    </div>
  );
};

export default BassDistantSuitePage;
